<div class="hidden md:block rounded-lg overflow-x-auto overflow-y-auto shadow max-h-[80vh]">
    <table mat-table [dataSource]="dataSource" [ngStyle]="getContainerStyle()">
        <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getHeaderStyle()">
                {{ col.label }}
            </th>
            <td mat-cell *matCellDef="let element" [ngStyle]="getCellStyle()">
                <!-- Caso NO editable -->
                <span *ngIf="!col.editable ">
                    {{ formatValue(col, element) }}
                    <!-- {{ element[col.key] }} -->
                </span>

                <!-- Caso editable -->
                <ng-container *ngIf="col.editable" [ngSwitch]="col.type">
                    <!-- Select -->
                    <mat-form-field [appearance]="col.styleInput" *ngSwitchCase="'select'" class="pt-3">
                        <mat-select [(ngModel)]="element[col.key]" (ngModelChange)="onValueChange()">
                            <mat-option
                                *ngFor="let item of (col.selectConfig.dataValue ?? element[col.selectConfig.dataReference])"
                                [value]="item">
                                {{ item[col.selectConfig.label] }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- Input genérico -->
                    <mat-form-field [appearance]="col.styleInput" *ngSwitchDefault class="pt-3">
                        <mat-label *ngIf="col.inputLabelVisible">{{ col.label }}</mat-label>
                        <input matInput [type]="col.type" [(ngModel)]="element[col.key]"
                            (ngModelChange)="onValueChange()" (focus)="$event.target.select()">
                    </mat-form-field>
                </ng-container>
            </td>

            <td mat-footer-cell *matFooterCellDef class="bg-slate-200 text-center">
                <span *ngIf="col.isTotalCount">
                    $ {{getTotal(col.key) | number:'1.2-2' }}
                </span>

                <span *ngIf="!col.isTotalCount"></span>
            </td>
        </ng-container>
        <!-- 
    <ng-container matColumnDef='acciones'>
        <th mat-header-cell *matHeaderCellDef [class]="color_primario ? '' : default_color"
            [style.background]="color_primario || '' " class="rounded-tr-lg text-white w-auto">
        </th>
        <td mat-cell *matCellDef='let movimiento'>
            <button mat-icon-button [class]="color_primario ? '' : default_color"
                [style.background]="color_primario || '' " (click)="deleteMovimiento(movimiento)" #delete>
                <mat-icon class="text-white w-auto">delete</mat-icon>
            </button>
        </td>
    </ng-container> -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <ng-container *ngIf="existTotalRow">
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </ng-container>
        <tr *matNoDataRow>
            <td [ngStyle]="getCellStyle()" [attr.colspan]="displayedColumns.length">
                No hay datos disponibles
            </td>
        </tr>

    </table>
</div>

<!-- Contenedor responsive para las cards -->
<div class="block md:hidden">
    <div class="max-w-md mx-auto space-y-4 p-2">
        <!-- Caso SIN datos -->
        <div *ngIf="!dataSource || dataSource.length === 0"
            class="p-4 rounded-lg shadow border text-center text-gray-600">
            No hay datos disponibles
        </div>

        <div *ngFor="let element of dataSource; let i = index" [ngStyle]="getCardStyle(i)">
            <div class="grid gap-3">
                <div *ngFor="let col of columnsSchema" class="flex flex-col">
                    <ng-container *ngIf="col.visible !== false">
                        <div [ngStyle]="getRowStyle()">
                            <label class="text-xs font-medium text-gray-600 mb-1">{{ col.label }}</label>
                            <span *ngIf="!col.editable" class="text-sm text-gray-800 text-right">
                                {{ formatValue(col, element) }}
                                <!-- {{ element[col.key] || '-' }} -->
                            </span>
                        </div>

                        <ng-container *ngIf="col.editable" [ngSwitch]="col.type">
                            <!-- Select -->
                            <mat-form-field [appearance]="col.styleInput" *ngSwitchCase="'select'"
                                [ngStyle]="getInputStyle()">
                                <mat-select [(ngModel)]="element[col.key]" (ngModelChange)="onValueChange()">
                                    <mat-option
                                        *ngFor="let item of col.selectConfig.dataValue ?? element[col.selectConfig.dataReference]"
                                        [value]="item">
                                        {{ item[col.selectConfig.label] }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <!-- Input genérico -->
                            <mat-form-field [appearance]="col.styleInput" *ngSwitchDefault [ngStyle]="getInputStyle()">
                                <mat-label *ngIf="col.inputLabelVisible">{{ col.label }}</mat-label>
                                <input matInput [type]="col.type" [(ngModel)]="element[col.key]"
                                    (ngModelChange)="onValueChange()" (focus)="$event.target.select()" />
                            </mat-form-field>
                        </ng-container>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngFor="let col of columnsSchema">
        <div class="flex w-full gap-1 justify-between mt-2" *ngIf="col?.isTotalCount">
            <span class="italic">Total {{col.label}}:</span>
            <span class="font-bold">$ {{getTotal(col.key) | number:'1.2-2' }}</span>
        </div>
    </ng-container>
</div>


<!-- Mostrar el contador de items -->
<div class="flex w-full items-center my-2 px-4">
    <span class="flex-grow"></span>
    <label class="text-gray-700 text-sm">
        Total de items: {{ dataSource.length }}
    </label>
</div>